export const UCDOMAIN = {
  URBANCLAP: 'marc.urbanclap.com',
  URBANCOMPANY: 'marc.urbancompany.com',
}

export const BRAND_KEY = {
  URBAN_COMPANY:'urbanCompany',
};

export const DEFAULT_BRAND_KEY = BRAND_KEY.URBAN_COMPANY;

export const HOST_TO_BRAND_KEY_MAP = {
  [UCDOMAIN.URBANCOMPANY]: BRAND_KEY.URBAN_COMPANY,
};
